import * as RRadio from '@radix-ui/react-radio-group';
import type { ReactNode } from 'react';
import { cn } from './cn';

export interface RadioOption {
  value: string;
  label: ReactNode;
  disabled?: boolean;
}

export interface RadioGroupProps {
  value?: string;
  onChange?: (value: string) => void;
  options: RadioOption[];
  /** Lay options out in a row instead of a column. */
  inline?: boolean;
  disabled?: boolean;
  className?: string;
}

/** Radio group (replaces antd Radio.Group) built on Radix RadioGroup. */
export function RadioGroup({ value, onChange, options, inline, disabled, className }: RadioGroupProps) {
  return (
    <RRadio.Root
      value={value}
      onValueChange={onChange}
      disabled={disabled}
      className={cn('flex gap-x-5 gap-y-2', inline ? 'flex-row flex-wrap items-center' : 'flex-col', className)}
    >
      {options.map((o) => (
        <label
          key={o.value}
          className={cn('inline-flex items-center gap-2 text-sm text-content', (o.disabled || disabled) ? 'cursor-not-allowed opacity-50' : 'cursor-pointer')}
        >
          <RRadio.Item
            value={o.value}
            disabled={o.disabled}
            className="grid size-[18px] shrink-0 place-items-center rounded-pill border border-line bg-surface transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40 data-[state=checked]:border-brand-600"
          >
            <RRadio.Indicator className="size-2.5 rounded-pill bg-brand-600" />
          </RRadio.Item>
          {o.label}
        </label>
      ))}
    </RRadio.Root>
  );
}
